import { render, staticRenderFns } from "./RecycleContactsList.vue?vue&type=template&id=81bea0ee&scoped=true&lang=pug&"
import script from "./RecycleContactsList.vue?vue&type=script&lang=js&"
export * from "./RecycleContactsList.vue?vue&type=script&lang=js&"
import style0 from "./RecycleContactsList.vue?vue&type=style&index=0&id=81bea0ee&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bea0ee",
  null
  
)

export default component.exports